var _dec, _dec2, _dec3, _dec4, _dec5, _dec6, _dec7, _dec8, _dec9, _dec10, _dec11, _dec12, _dec13, _dec14, _dec15, _dec16, _dec17, _dec18, _dec19, _dec20, _dec21, _dec22, _dec23, _dec24, _dec25, _dec26, _dec27, _dec28, _dec29, _dec30, _dec31, _dec32, _dec33, _dec34, _dec35, _dec36, _dec37, _dec38, _dec39, _dec40, _class, _descriptor, _descriptor2, _descriptor3, _descriptor4, _descriptor5, _descriptor6, _descriptor7, _descriptor8, _descriptor9, _descriptor10, _descriptor11, _descriptor12, _descriptor13, _descriptor14, _descriptor15, _descriptor16, _descriptor17, _descriptor18, _descriptor19, _descriptor20, _descriptor21, _descriptor22, _descriptor23, _descriptor24, _descriptor25, _descriptor26, _descriptor27, _descriptor28, _descriptor29, _descriptor30, _descriptor31, _descriptor32, _descriptor33, _descriptor34, _descriptor35, _descriptor36, _descriptor37, _descriptor38, _descriptor39, _descriptor40, _BaseTreatmentFilledJournalEvent;
function _initializerDefineProperty(e, i, r, l) { r && Object.defineProperty(e, i, { enumerable: r.enumerable, configurable: r.configurable, writable: r.writable, value: r.initializer ? r.initializer.call(l) : void 0 }); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
function _initializerWarningHelper(r, e) { throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform."); }
import { attr, belongsTo } from "@ember-data/model";
import JournalEvent from "core/models/journal-event";
import { validateInclusion, validateNumber, validatePresence } from "ember-changeset-validations/validators";
import IntlService from "ember-intl/services/intl";
import Patient from "./patient";
let BaseTreatmentFilledJournalEvent = (_dec = attr("boolean", {
  allowNull: true
}), _dec2 = attr("number"), _dec3 = attr("boolean", {
  allowNull: true
}), _dec4 = attr("string"), _dec5 = attr("boolean", {
  allowNull: true
}), _dec6 = attr("string"), _dec7 = attr("boolean", {
  allowNull: true
}), _dec8 = attr("string"), _dec9 = attr("number"), _dec10 = attr("boolean", {
  allowNull: true
}), _dec11 = attr("number"), _dec12 = attr("boolean", {
  allowNull: true
}), _dec13 = attr("boolean", {
  allowNull: true
}), _dec14 = attr("string"), _dec15 = attr("boolean", {
  allowNull: true
}), _dec16 = attr("string"), _dec17 = attr("boolean", {
  allowNull: true
}), _dec18 = attr("boolean", {
  allowNull: true
}), _dec19 = attr("string"), _dec20 = attr("boolean", {
  allowNull: true
}), _dec21 = attr("string"), _dec22 = attr("boolean", {
  allowNull: true
}), _dec23 = attr("string"), _dec24 = attr("boolean", {
  allowNull: true
}), _dec25 = attr("boolean", {
  allowNull: true
}), _dec26 = attr("number"), _dec27 = attr("boolean", {
  allowNull: true
}), _dec28 = attr("string"), _dec29 = attr("string"), _dec30 = attr("boolean", {
  allowNull: true
}), _dec31 = attr("boolean", {
  allowNull: true
}), _dec32 = attr("string"), _dec33 = attr("string"), _dec34 = attr("boolean", {
  allowNull: true
}), _dec35 = attr("boolean", {
  allowNull: true
}), _dec36 = attr("string"), _dec37 = attr("boolean", {
  allowNull: true
}), _dec38 = attr("boolean", {
  allowNull: true
}), _dec39 = attr("string"), _dec40 = belongsTo("patient", {
  async: false,
  inverse: "preTreatmentFilledJournalEvents"
}), _class = (_BaseTreatmentFilledJournalEvent = class BaseTreatmentFilledJournalEvent extends JournalEvent {
  constructor(...args) {
    super(...args);
    _initializerDefineProperty(this, "temperatureIssue", _descriptor, this);
    _initializerDefineProperty(this, "temperature", _descriptor2, this);
    _initializerDefineProperty(this, "fatigueIssue", _descriptor3, this);
    _initializerDefineProperty(this, "fatigue", _descriptor4, this);
    _initializerDefineProperty(this, "coughIssue", _descriptor5, this);
    _initializerDefineProperty(this, "cough", _descriptor6, this);
    _initializerDefineProperty(this, "breathIssue", _descriptor7, this);
    _initializerDefineProperty(this, "breath", _descriptor8, this);
    _initializerDefineProperty(this, "currentWeight", _descriptor9, this);
    _initializerDefineProperty(this, "weightLossIssue", _descriptor10, this);
    _initializerDefineProperty(this, "weightLoss", _descriptor11, this);
    _initializerDefineProperty(this, "dermatologicalIssue", _descriptor12, this);
    _initializerDefineProperty(this, "skinRashIssue", _descriptor13, this);
    _initializerDefineProperty(this, "skinRashLocation", _descriptor14, this);
    _initializerDefineProperty(this, "itchingIssue", _descriptor15, this);
    _initializerDefineProperty(this, "itchingLocation", _descriptor16, this);
    _initializerDefineProperty(this, "dermatologicalTreatmentEfficient", _descriptor17, this);
    _initializerDefineProperty(this, "nauseaVomitingIssue", _descriptor18, this);
    _initializerDefineProperty(this, "nauseaVomiting", _descriptor19, this);
    _initializerDefineProperty(this, "diarrheaIssue", _descriptor20, this);
    _initializerDefineProperty(this, "diarrhea", _descriptor21, this);
    _initializerDefineProperty(this, "constipationIssue", _descriptor22, this);
    _initializerDefineProperty(this, "constipation", _descriptor23, this);
    _initializerDefineProperty(this, "constipationTreatmentEfficient", _descriptor24, this);
    _initializerDefineProperty(this, "painIssue", _descriptor25, this);
    _initializerDefineProperty(this, "pain", _descriptor26, this);
    _initializerDefineProperty(this, "muscularPainIssue", _descriptor27, this);
    _initializerDefineProperty(this, "muscularPainLevel", _descriptor28, this);
    _initializerDefineProperty(this, "muscularPainLocation", _descriptor29, this);
    _initializerDefineProperty(this, "muscularPainTreatmentEfficient", _descriptor30, this);
    _initializerDefineProperty(this, "articularPainIssue", _descriptor31, this);
    _initializerDefineProperty(this, "articularPainLevel", _descriptor32, this);
    _initializerDefineProperty(this, "articularPainLocation", _descriptor33, this);
    _initializerDefineProperty(this, "articularPainTreatmentEfficient", _descriptor34, this);
    _initializerDefineProperty(this, "otherPainIssue", _descriptor35, this);
    _initializerDefineProperty(this, "otherPainLocations", _descriptor36, this);
    _initializerDefineProperty(this, "otherPainTreatmentEfficient", _descriptor37, this);
    _initializerDefineProperty(this, "hasAlertingValue", _descriptor38, this);
    _initializerDefineProperty(this, "originTaskIdentifier", _descriptor39, this);
    //---- End of generated code ----
    _initializerDefineProperty(this, "patient", _descriptor40, this);
  }
  static validations(intl) {
    return {
      currentWeight: validateNumber({
        allowBlank: true,
        description: intl.t("validations.pre-treatment-filled-journal-event.current-weight")
      }),
      weightLoss: validateNumber({
        allowBlank: true,
        description: intl.t("validations.pre-treatment-filled-journal-event.weight-loss")
      }),
      pain: validateNumber({
        allowBlank: true,
        description: intl.t("validations.pre-treatment-filled-journal-event.pain")
      }),
      temperature: validateInclusion({
        list: ["1", "2"],
        allowBlank: true,
        description: intl.t("validations.pre-treatment-filled-journal-event.temperature")
      }),
      fatigue: validateInclusion({
        list: ["0", "1", "2"],
        allowBlank: true,
        description: intl.t("validations.pre-treatment-filled-journal-event.fatigue")
      }),
      cough: validateInclusion({
        list: ["0", "1", "2", "3", "4"],
        allowBlank: true,
        description: intl.t("validations.pre-treatment-filled-journal-event.cough")
      }),
      breath: validateInclusion({
        list: ["0", "1", "2", "3", "4"],
        allowBlank: true,
        description: intl.t("validations.pre-treatment-filled-journal-event.breath")
      }),
      nauseaVomiting: validateInclusion({
        list: ["0", "1", "2"],
        allowBlank: true,
        description: intl.t("validations.pre-treatment-filled-journal-event.nausea-vomiting")
      }),
      diarrhea: validateInclusion({
        list: ["0", "1", "2"],
        allowBlank: true,
        description: intl.t("validations.pre-treatment-filled-journal-event.diarrhea")
      }),
      constipation: validateInclusion({
        list: ["0", "1"],
        allowBlank: true,
        description: intl.t("validations.pre-treatment-filled-journal-event.constipation")
      }),
      muscularPainLevel: validateInclusion({
        list: ["0", "1", "2"],
        allowBlank: true,
        description: intl.t("validations.pre-treatment-filled-journal-event.muscular-pain-level")
      }),
      articularPainLevel: validateInclusion({
        list: ["0", "1", "2"],
        allowBlank: true,
        description: intl.t("validations.pre-treatment-filled-journal-event.articular-pain-level")
      }),
      occurredAt: validatePresence({
        presence: true,
        description: intl.t("validations.occurred-at")
      })
    };
  }
  get baseSectionsWithColor() {
    return [{
      key: "temperature",
      label: `Température`,
      color: `${this.temperatureIssue ? (temperatureValue => {
        if (temperatureValue > 38.5) {
          return "red";
        }
        if (temperatureValue >= 38) {
          return "orange";
        }
        return "green";
      })(this.temperature) : "green"}`,
      answers: this.temperatureIssue ? [`Température : ${this.temperature}°C`] : ["Non"]
    }, {
      key: "fatigue",
      label: "Fatigue",
      color: `${this.fatigueIssue ? (fatigueValue => {
        if (fatigueValue == "2") {
          return "red";
        }
        if (fatigueValue == "1") {
          return "orange";
        }
        return "green";
      })(this.fatigue) : "green"}`,
      answers: this.fatigueIssue ? (fatigueValue => {
        switch (fatigueValue) {
          case "2":
            return ["Sévère"];
          case "1":
            return ["Modérée"];
          case "0":
          default:
            return ["Légère"];
        }
      })(this.fatigue) : ["Non"]
    }, {
      key: "cough",
      label: "Toux",
      color: `${this.coughIssue ? (coughValue => {
        if (coughValue == "4") {
          return "red";
        }
        if (coughValue == "3") {
          return "orange";
        }
        return "green";
      })(this.cough) : "green"}`,
      answers: this.coughIssue ? (coughValue => {
        switch (coughValue) {
          case "4":
            return ["Très sévère"];
          case "3":
            return ["Sévère"];
          case "2":
            return ["Modérée"];
          case "1":
            return ["Légère"];
          case "0":
          default:
            return ["Aucune"];
        }
      })(this.cough) : ["Non"]
    }, {
      key: "breath",
      label: "Difficultés à respirer",
      color: `${this.breathIssue ? (breathValue => {
        if (breathValue == "4") {
          return "red";
        }
        if (breathValue == "3") {
          return "orange";
        }
        return "green";
      })(this.breath) : "green"}`,
      answers: this.breathIssue ? (breathValue => {
        switch (breathValue) {
          case "4":
            return ["Très sévère"];
          case "3":
            return ["Sévère"];
          case "2":
            return ["Modérée"];
          case "1":
            return ["Légère"];
          case "0":
          default:
            return ["Aucune"];
        }
      })(this.breath) : ["Non"]
    }, {
      key: "weight",
      label: "Poids",
      color: `${this.weightLossIssue ? ((currentWeight, weightLoss) => {
        if (weightLoss / currentWeight > 0.1) {
          return "red";
        }
        return "green";
      })(this.currentWeight, this.weightLoss) : "green"}`,
      answers: this.weightLossIssue ? ((currentWeight, weightLoss) => {
        if (weightLoss / currentWeight > 0.1) {
          return [`Poids actuel : ${this.currentWeight}kg`, `Perte de poids importante : ${Math.round(weightLoss / currentWeight * 100)}%`];
        }
        return [`Poids actuel : ${this.currentWeight}kg`];
      })(this.currentWeight, this.weightLoss) : [`Poids actuel : ${this.currentWeight}kg`]
    }, {
      key: "dermatological",
      label: "Troubles dermatologiques",
      color: `${this.dermatologicalIssue ? "red" : "green"}`,
      answers: this.dermatologicalIssue ? ((skinRashIssue, skinRashLocation, itchingIssue, itchingLocation, dermatologicalTreatmentEfficient) => {
        const toReturn = [];
        if (skinRashIssue) {
          toReturn.push(`Eruptions cutanées : ${skinRashLocation}`);
        }
        if (itchingIssue) {
          toReturn.push(`Démangeaisons : ${itchingLocation}`);
        }
        toReturn.push(`Traitement efficace : ${dermatologicalTreatmentEfficient ? "oui" : "non"}`);
        return toReturn;
      })(this.skinRashIssue, this.skinRashLocation, this.itchingIssue, this.itchingLocation, this.dermatologicalTreatmentEfficient) : ["Non"]
    }, {
      key: "nausea-vomiting",
      label: "Nausées/vomissements",
      color: `${this.nauseaVomitingIssue ? (nauseaVomitingValue => {
        if (nauseaVomitingValue == "2") {
          return "red";
        }
        if (nauseaVomitingValue == "1") {
          return "orange";
        }
        return "green";
      })(this.nauseaVomiting) : "green"}`,
      answers: this.nauseaVomitingIssue ? (nauseaVomitingValue => {
        switch (nauseaVomitingValue) {
          case "2":
            return ["Sévère"];
          case "1":
            return ["Modéré"];
          case "0":
          default:
            return ["Faible"];
        }
      })(this.nauseaVomiting) : ["Non"]
    }, {
      key: "diarrhea",
      label: "Diarrhées",
      color: `${this.diarrheaIssue ? (diarrheaValue => {
        if (diarrheaValue == "2") {
          return "red";
        }
        if (diarrheaValue == "1") {
          return "orange";
        }
        return "green";
      })(this.diarrhea) : "green"}`,
      answers: this.diarrheaIssue ? (diarrheaValue => {
        switch (diarrheaValue) {
          case "2":
            return ["Sévère"];
          case "1":
            return ["Modéré"];
          case "0":
          default:
            return ["Faible"];
        }
      })(this.diarrhea) : ["Non"]
    }, {
      key: "constipation",
      label: "Constipation",
      color: `${this.constipationIssue ? (constipationValue => {
        if (constipationValue == "1") {
          return "red";
        }
        return "green";
      })(this.constipation) : "green"}`,
      answers: this.constipationIssue ? (constipationValue => {
        switch (constipationValue) {
          case "1":
            return ["Persistante"];
          case "0":
          default:
            return ["Occasionnelle"];
        }
      })(this.constipation) : ["Non"]
    }, {
      key: "pain",
      label: "Douleurs",
      color: `${this.painIssue ? (painValue => {
        if (painValue >= 7) {
          return "red";
        }
        if (painValue >= 4) {
          return "orange";
        }
        return "green";
      })(this.pain) : "green"}`,
      answers: this.painIssue ? (painValue => {
        if (painValue >= 7) {
          return [`Douleur intense : ${painValue}/10`];
        }
        if (painValue >= 4) {
          return [`Douleur modérée : ${painValue}/10`];
        }
        return [`Douleur faible : ${painValue}/10`];
      })(this.pain) : ["Non"]
    }, {
      key: "muscularPain",
      label: "Douleurs musculaires",
      color: `${this.muscularPainIssue ? "red" : "green"}`,
      answers: this.muscularPainIssue ? ((muscularPainLevel, muscularPainLocation, muscularPainTreatmentEfficient) => {
        const toReturn = [];
        if (muscularPainLevel == "2") {
          toReturn.push(`Douleur avec faiblesse sévère`);
        }
        if (muscularPainLevel == "1") {
          toReturn.push(`Douleur modérée avec faiblesse`);
        }
        if (muscularPainLevel == "0") {
          toReturn.push(`Douleur légère`);
        }
        toReturn.push(muscularPainLocation);
        toReturn.push(`Traitement efficace : ${muscularPainTreatmentEfficient ? "oui" : "non"}`);
        return toReturn;
      })(this.muscularPainLevel, this.muscularPainLocation, this.muscularPainTreatmentEfficient) : ["Non"]
    }, {
      key: "articularPain",
      label: "Douleurs articulaires",
      color: `${this.articularPainIssue ? "red" : "green"}`,
      answers: this.articularPainIssue ? ((articularPainLevel, articularPainLocation, articularPainTreatmentEfficient) => {
        const toReturn = [];
        if (articularPainLevel == "2") {
          toReturn.push(`Douleur avec faiblesse sévère`);
        }
        if (articularPainLevel == "1") {
          toReturn.push(`Douleur modérée avec faiblesse`);
        }
        if (articularPainLevel == "0") {
          toReturn.push(`Douleur légère`);
        }
        toReturn.push(articularPainLocation);
        toReturn.push(`Traitement efficace : ${articularPainTreatmentEfficient ? "oui" : "non"}`);
        return toReturn;
      })(this.articularPainLevel, this.articularPainLocation, this.articularPainTreatmentEfficient) : ["Non"]
    }, {
      key: "otherPain",
      label: "Douleurs autres",
      color: `${this.otherPainIssue ? "red" : "green"}`,
      answers: this.otherPainIssue ? ((otherPainLocation, otherPainTreatmentEfficient) => {
        const toReturn = [];
        toReturn.push(otherPainLocation);
        toReturn.push(`Traitement efficace : ${otherPainTreatmentEfficient ? "oui" : "non"}`);
        return toReturn;
      })(this.otherPainLocations, this.otherPainTreatmentEfficient) : ["Non"]
    }];
  }
}, _defineProperty(_BaseTreatmentFilledJournalEvent, "type", "pre-treatment-filled-journal-event"), _defineProperty(_BaseTreatmentFilledJournalEvent, "baseSections", ["temperatureIssue", "temperature", "fatigueIssue", "fatigue", "coughIssue", "cough", "breathIssue", "breath", "currentWeight", "weightLossIssue", "weightLoss", "pacPainful", "pacInflammatory", "pacFlowing", "pacHealing", "dermatologicalIssue", "skinRashIssue", "skinRashLocation", "itchingIssue", "itchingLocation", "dermatologicalTreatmentEfficient", "skinRashIssue", "skinRashLocation", "itchingIssue", "itchingLocation", "nauseaVomitingIssue", "nauseaVomiting", "diarrheaIssue", "diarrhea", "constipationIssue", "constipation", "constipationTreatmentEfficient", "painIssue", "pain", "muscularPainIssue", "muscularPainLevel", "muscularPainLocation", "muscularPainTreatmentEfficient", "articularPainIssue", "articularPainLevel", "articularPainLocation", "articularPainTreatmentEfficient", "otherPainIssue", "otherPainLocation", "otherPainTreatmentEfficient", "cortisone", "cortisoneDosageGt20", "radiotherapy"]), _BaseTreatmentFilledJournalEvent), _descriptor = _applyDecoratedDescriptor(_class.prototype, "temperatureIssue", [_dec], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "temperature", [_dec2], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor3 = _applyDecoratedDescriptor(_class.prototype, "fatigueIssue", [_dec3], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor4 = _applyDecoratedDescriptor(_class.prototype, "fatigue", [_dec4], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor5 = _applyDecoratedDescriptor(_class.prototype, "coughIssue", [_dec5], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor6 = _applyDecoratedDescriptor(_class.prototype, "cough", [_dec6], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor7 = _applyDecoratedDescriptor(_class.prototype, "breathIssue", [_dec7], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor8 = _applyDecoratedDescriptor(_class.prototype, "breath", [_dec8], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor9 = _applyDecoratedDescriptor(_class.prototype, "currentWeight", [_dec9], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor10 = _applyDecoratedDescriptor(_class.prototype, "weightLossIssue", [_dec10], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor11 = _applyDecoratedDescriptor(_class.prototype, "weightLoss", [_dec11], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor12 = _applyDecoratedDescriptor(_class.prototype, "dermatologicalIssue", [_dec12], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor13 = _applyDecoratedDescriptor(_class.prototype, "skinRashIssue", [_dec13], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor14 = _applyDecoratedDescriptor(_class.prototype, "skinRashLocation", [_dec14], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor15 = _applyDecoratedDescriptor(_class.prototype, "itchingIssue", [_dec15], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor16 = _applyDecoratedDescriptor(_class.prototype, "itchingLocation", [_dec16], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor17 = _applyDecoratedDescriptor(_class.prototype, "dermatologicalTreatmentEfficient", [_dec17], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor18 = _applyDecoratedDescriptor(_class.prototype, "nauseaVomitingIssue", [_dec18], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor19 = _applyDecoratedDescriptor(_class.prototype, "nauseaVomiting", [_dec19], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor20 = _applyDecoratedDescriptor(_class.prototype, "diarrheaIssue", [_dec20], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor21 = _applyDecoratedDescriptor(_class.prototype, "diarrhea", [_dec21], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor22 = _applyDecoratedDescriptor(_class.prototype, "constipationIssue", [_dec22], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor23 = _applyDecoratedDescriptor(_class.prototype, "constipation", [_dec23], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor24 = _applyDecoratedDescriptor(_class.prototype, "constipationTreatmentEfficient", [_dec24], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor25 = _applyDecoratedDescriptor(_class.prototype, "painIssue", [_dec25], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor26 = _applyDecoratedDescriptor(_class.prototype, "pain", [_dec26], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor27 = _applyDecoratedDescriptor(_class.prototype, "muscularPainIssue", [_dec27], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor28 = _applyDecoratedDescriptor(_class.prototype, "muscularPainLevel", [_dec28], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor29 = _applyDecoratedDescriptor(_class.prototype, "muscularPainLocation", [_dec29], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor30 = _applyDecoratedDescriptor(_class.prototype, "muscularPainTreatmentEfficient", [_dec30], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor31 = _applyDecoratedDescriptor(_class.prototype, "articularPainIssue", [_dec31], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor32 = _applyDecoratedDescriptor(_class.prototype, "articularPainLevel", [_dec32], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor33 = _applyDecoratedDescriptor(_class.prototype, "articularPainLocation", [_dec33], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor34 = _applyDecoratedDescriptor(_class.prototype, "articularPainTreatmentEfficient", [_dec34], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor35 = _applyDecoratedDescriptor(_class.prototype, "otherPainIssue", [_dec35], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor36 = _applyDecoratedDescriptor(_class.prototype, "otherPainLocations", [_dec36], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor37 = _applyDecoratedDescriptor(_class.prototype, "otherPainTreatmentEfficient", [_dec37], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor38 = _applyDecoratedDescriptor(_class.prototype, "hasAlertingValue", [_dec38], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor39 = _applyDecoratedDescriptor(_class.prototype, "originTaskIdentifier", [_dec39], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor40 = _applyDecoratedDescriptor(_class.prototype, "patient", [_dec40], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _class);
export { BaseTreatmentFilledJournalEvent as default };